import React, { useEffect } from "react";
import { FxLabel } from "./FxLabel";
import { getDefaultDate, getHstime, getHstimeFromDate } from "./FxDate";
import { DateUtil } from "./../datas/DateUtil";

function render(d) {
  const s = getHstimeFromDate(d);
  try {
    /* Date and time is separated with a capital T.
    UTC time is defined with a capital letter Z.
    */
    return s.slice(0, 4) + "-" + s.slice(4, 6) + "-" + s.slice(6, 8) + "T" + s.slice(8, 10) + ":" + s.slice(10, 12);
  } catch (e) {
    return "";
  }

}

export const FxDateTime = (props) => {
  const { attr, onChangeValue, fxInObj, inputType } = props;
  const disabled = attr.readOnlyYn === "Y";
  const sx = { width : "210px" };

  let defaultDate = fxInObj[attr.attrName]
    ? DateUtil.getDate(fxInObj[attr.attrName])
    : getDefaultDate(attr.attrDftVal);

  const onChange = (event) => {
    const vals = event.target.value.split("");
    onChangeValue(event.target.id, getHstime(vals));
  };

  useEffect(() => {
    //로딩되면 입력객체에 값을 설정한다.
    onChangeValue(attr.attrName, getHstimeFromDate(defaultDate));
  }, [attr]);
  
  return (
    <>
      <FxLabel attr={attr} inputType={inputType} />
      <input
        className="FxDateTime"
        type="datetime-local"
        id={attr.attrName}
        style={sx}
        defaultValue={render(defaultDate)}
        disabled={disabled}
        onChange={onChange}
      />
    </>
  );
};



export const FxDateTime2 = (props) => {
  const { attrClass, para } = props;
  const sx = attrClass.getStyle();
  const defaultDate = props.defaultValue ? DateUtil.getDate(props.defaultValue) : getDefaultDate(attrClass.getAttr().attrDftVal);

  sx.minWidth = '210px';
  sx.width = sx.minWidth;

  const onChange = (event) => {
    const vals = event.target.value.split("");
    if (para.onChange) para.onChange(event.target.id, getHstime(vals));
  };

  useEffect(() => {
    //로딩되면 입력객체에 값을 설정한다.
    para.onChange(attrClass.getId(), getHstimeFromDate(defaultDate));
  }, [attrClass]);

  return (
    <>
      <input
        className="FxDateTime"
        type="datetime-local"
        id={attrClass.getId()}
        style={sx}
        defaultValue={render(defaultDate)}
        disabled={attrClass.isDisabled()}
        onChange={onChange}
      />
    </>
  );
};
